import React from 'react';

const CButton = ({ children, className = '', onClick = undefined, isLoading = false, disabled = false }) => {
  return (
    <button
      className={`btn btn-sm rounded-pill shadow-none ${className}`}
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <>
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {/* {' Loading...'} */}
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default CButton;
